<template>
  <div class="container" v-if="this.datosRegistro != null">

    <aside class="bg-primary bg-gradient rounded-1 p-0 p-sm-1 mt-1">
      <div
          class="d-flex align-items-center justify-content-between flex-column flex-xl-row text-center text-xl-start">
        <div class="mb-4 mb-xl-0">
          <div class="fs-3 fw-bold text-white">
            <span v-if="this.datosRegistro.id==null">Registrar Nueva Sucursal</span>
            <span v-else>Editar Sucursal</span>
          </div>
        </div>
      </div>
    </aside>

    <div class="row">
      <div class="col-4">
        <div class="btn-group" role="group"  style="width: 100%">
          <span class="text" style="margin: auto;">Cliente:</span>
          <v-select :options="optionsCliente" v-model="datosRegistro.id_cliente"
                    label="cliente"
                    :reduce="it => it.id"
                    class="m-4" placeholder="--Selecciona--"
                    style="width: 100%"
          />
        </div>
      </div>
      <div class="col-4">
        <span class="text">Sucursal:</span>
        <input v-model="datosRegistro.nombre_sucursal" class="m-4" type="text" placeholder="Sucursal">
      </div>
      <div class="col-4">
        <span class="text">Alias:</span>
        <input v-model="datosRegistro.alias_sucursal" class="m-4" type="text" placeholder="Alias">
      </div>
      <div class="col-12">

        <div class="row">
          <div class="col-10">
            <span class="text" >Turnos:</span>
          </div>
          <div class="col-2">
            <button type="button" class="btn btn-success btn-sm"
                    @click="agregarTurno()">
              <FontAwesomeIcon :icon="faPlus()"/>
              Agregar Turno
            </button>
          </div>
        </div>
        <div >
          <table class="table table-striped table-border">
            <thead>
            <tr>
              <th width="10%" class="header" scope="col">ID</th>
              <th width="20%" class="header" scope="col">Nombre Turno</th>
              <th width="20%" class="header" scope="col">Requiere evidencia</th>
              <th width="20%" class="header" scope="col">Hora inicio</th>
              <th width="20%" class="header" scope="col">Hora fin</th>
              <th width="10%" class="header" scope="col">Activo</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, idx) in datosRegistro.turnos" v-bind:key="item.id">
              <th scope="row">{{ item.id }}</th>
              <th scope="row">
                <input v-model="item.nombre_turno" type="text" placeholder="Turno">
              </th>
              <th scope="row">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" v-model="item.evidencias">
                </div>
              </th>
              <th scope="row">
                <div class="form-checko form-switch">
                  <VueDatePicker v-model="item.hora_inicio" time-picker />
                </div>
              </th>
              <th scope="row">
                <div class="form-check form-switch">
                  <VueDatePicker v-model="item.hora_fin" time-picker />
                </div>
              </th>
              <th scope="row">
                <div class="form-check form-switch">
                  <input v-if="item.id != null" class="form-check-input" type="checkbox" v-model="item.registro_activo">
                  <button v-else class="btn btn-danger m-1"
                          @click="quitarTurno(idx)" title="Quitar">
                    <FontAwesomeIcon :icon="faDesActivar()"/>
                  </button>
                </div>
              </th>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col" align="center">
        <button class="btn btn-success " @click="registrar()">Guardar</button>
      </div>
      <div class="col" align="center">
        <button class="btn btn-danger " @click="cancelar()">Cancelar</button>
      </div>
    </div>
  </div>
</template>

<script>
import {inject, ref} from "vue";
import {SucursalService} from "@/services/SucursalService";
import {faPlus, faTrash} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  components: {FontAwesomeIcon},

  inject: ['$axios', '$localStorageService'],
  setup() {
    return {
      srv_SucursalService: new SucursalService(inject('$axios'))
    }
  },
  props: {
    original: Object,
    optionsCliente: Array
  },
  data() {
    return {
      datosRegistro: {
        id: null,
        nombre_sucursal: null,
        alias_sucursal: null,
        id_cliente: null,
        turnos: []
      },
    }
  },
  mounted() {
    if (this.original != null && this.original.id != null) {
      this.obtener();
    }
  },
  methods: {
    faDesActivar() {
      return faTrash;
    },
    faPlus() {
      return faPlus;
    },
    async obtener() {

      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_SucursalService.obtener({
        nombre_sucursal: ""+this.original.id,
        get_full: true
      }).then((response) => {
        if (response != null && response.length > 0) {
          this.datosRegistro = response[0];
        }
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    async registrar() {
      let load = this.$loading.show({
        container: this.$refs.formContainer,//puede ponerse null
        canCancel: false,
        onCancel: this.onCancelLoader,
      });

      await this.srv_SucursalService.cargar(this.datosRegistro).then((res) => {
        this.$swal(res.msj);
        this.cancelar();
      }).catch((error) => {
        console.error(error)
        this.$swal(error.message);
      }).finally(() => load.hide());
    },
    cancelar() {
      this.$emit('_cancelarEditar');
    },
    agregarTurno() {
      if (this.datosRegistro.turnos == null) {
        this.datosRegistro.turnos = [];
      }
      this.datosRegistro.turnos.push({
        id: null,
        nombre_turno: null,
        evidencias: false,
        hora_inicio: ref({
          hours: new Date().getHours(),
          minutes: new Date().getMinutes()
        }),
        hora_fin: ref({
          hours: new Date().getHours(),
          minutes: new Date().getMinutes()
        }),
      })
    },
    quitarTurno(idx) {
      this.datosRegistro.turnos.splice(idx, 1);
    }
  }
}
</script>

<style scoped>

</style>